export const customerReplacementModels = state => state.getIn(['replacementModels', 'entities']);
export const replacementModelById = (state, id) => customerReplacementModels(state).get(String(id));
export const replacementModelsByIds = (state, ids) => ids.map(id =>
  customerReplacementModels(state).get(String(id)));
